// extracted by mini-css-extract-plugin
export default {"container":"ErrorScreen_container__Ne7aD","title":"ErrorScreen_title__xWWSY","content":"ErrorScreen_content__6Fk3U","buttonContainer":"ErrorScreen_buttonContainer__PeDp8"};